import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const LoadingList = lazy(() => import('./pages/LoadingList'));
const LoadingProcess = lazy(() => import('./pages/LoadingProcess'));

const loadingRoutes: RouteObject[] = [
    {
        index: true,
        element: <LoadingList />,
    },
    {
        path: ':id',
        element: <LoadingProcess />,
    },
];

export default loadingRoutes;
